import { Param } from './../../../model/common/param';
import { Component, ViewChild } from '@angular/core';
import { GenericManage, GenericManageViewMode } from '../../generic/generic.manage';
import { saveAs as fileSaveAs } from 'file-saver-es';
import { InterCompany } from '../../../model/api/assets/inter-company';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { AppUtils } from '../../../common/app.utils';
import { InsuranceCategory } from '../../../model/api/assets/insurance-category';
import { InsuranceCategoryList } from './insurance-category.list';
import { InsuranceCategoryDetail } from './insurance-category.detail';
import { InsuranceCategoryHttpService } from '../../../services/http/assets/insurance-category.http.service';

@Component({
    selector: 'insurance-category-manage',
    templateUrl: 'insurance-category.manage.html',
})
export class InsuranceCategoryManage extends GenericManage<InsuranceCategory, number> {

    @ViewChild('insuranceCategoryDetailModal') insuranceCategoryDetailModal: ModalDirective;
    @ViewChild('insuranceCategoryList') insuranceCategoryList: InsuranceCategoryList;
    @ViewChild('insuranceCategoryDetail') insuranceCategoryDetail: InsuranceCategoryDetail;

    public filter: string = '';
    isCollapsed: boolean = true;
    constructor(
        public insuranceCategoryHttpService: InsuranceCategoryHttpService) {
        super();
    }

    public addNewItem() {
        super.addNewItem();
    }

    public editItem() {
        super.editItem();
    }

    public detailInitialize() {
        super.detailInitialize();
        this.insuranceCategoryDetailModal.show();
    }

    public detailTerminate() {
        super.detailTerminate();
        this.insuranceCategoryDetailModal.hide();
    }


    public refresh() {
        let params: Array<Param> = new Array<Param>();

        params.push(new Param('filter', this.filter));

        this.insuranceCategoryList.refresh(params);
    }


    // public exportToExcel(){

    //      let params: Array<Param> = null;

    //     if ((this.filter != null) && (this.filter.length > 0)) {
    //         params = new Array<Param>();
    //         params.push(new Param('filter', this.filter));
    //     }

    //     this.locationHttpService.get(1, 10000000, 'code', 'asc', params, null).subscribe(
    //         (data: PagedResult<Location>) => {

    //             let options = {
    //                 sheetid: 'Buildings',
    //                 headers: true,
    //                 column: { style: { Font: { Bold: '1' } } },
    //                 rows: { 1: { style: { Font: { Color: '#FF0077' } } } },
    //                 cells: { 1: { 1: { style: { Font: { Color: '#00FFFF' } } } } }
    //             };

    //             alasql(`SELECT id as [Id],
    //                 code as [Cod],
    //                 name as [Denumire],
    //                 region->name as [Judet],
    //                 admCenter->name as [Regiune]
    //                 INTO XLSX("Buildings.xlsx",?) FROM ?`, [ options, data.items ]);

    //         });

    // }

    public getFilters(): Array<Param> {
        let params: Array<Param> = new Array<Param>();
        params.push(new Param('filter', this.filter));

        return params;
    }

    public exportToExcel() {

        let params: Array<Param> = null;

        params = this.getFilters();
        this.insuranceCategoryHttpService
            .export(params)
            .subscribe((blob) => {
                fileSaveAs(blob, 'InterCompanies.xlsx');
            });
    }

    collapsed(event: any): void {
        // console.log(event);
      }
    
      expanded(event: any): void {
        // console.log(event);
      }
}
